module.exports = __webpack_public_path__ + "img/warning.2722494f.svg";